import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Start from "./views/Start";
import { CITY_SELECT, CONFIG_PAGE, MAIN } from "./consts/routes";
import ConfigClientData from "./views/ConfigClientData";
import CitySelect from "./views/CitySelect";
import Page from "./views/Page";
import Planos from "./views/Planos";
import Contato from "./views/Contato";
import Noticias from "./views/Noticias";
import TrabalheConosco from "./views/TrabalheConosco";
import ListaPlanos from "./views/ListaPlanos";
import GeneroPlano from "./views/GeneroPlano";
import Faq from "./views/Faq";
import CalculadoraPlano from "./views/CalculadoraPlano";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: MAIN,
      name: "start",
      component: Start
    },
    {
      path: CONFIG_PAGE,
      name: "config",
      component: ConfigClientData
    },
    {
      path: CITY_SELECT,
      name: "city_select",
      component: CitySelect
    },
    {
      path: `${MAIN}/:cidade`,
      name: "start_inner",
      component: Page,
      children: [
        { path: "home", component: Home },
        // { path: "contato", component: Contato },
        // { path: "noticias", component: Noticias },
        { path: "trabalhe_conosco", component: TrabalheConosco },
        { path: "faq", component: Faq },
        { path: "calculadora_plano", component: CalculadoraPlano },
        // { path: "banco_de_talentos", component: TrabalheConosco },
        {
          path: "vtxpay",
          component: Home,
          beforeEnter() {
            const userAgent = navigator.userAgent;
            const match = userAgent.match(/(iPhone|Android)/i);
            if (match) {
              const os = match[0];

              if (os === "iPhone") {
                window.open("https://apps.apple.com/br/app/virtex-app/id1527307166", "_blank");
              } else if (os === "Android") {
                window.open(
                  "https://play.google.com/store/apps/details?id=com.virtex.mobile",
                  "_blank"
                );
              }
            }
          }
        },
        // {
        //   path: "covid",
        //   component: Home,
        //   beforeEnter() {
        //     window.open("https://covid.virtex.com.br", "_blank");
        //   }
        // },
        {
          path: "planos",
          component: Planos,
          children: [
            {
              path: "residencial",
              component: ListaPlanos,
              props: { residencial: true }
            },
            {
              path: "empresarial",
              component: ListaPlanos,
              props: { empresarial: true }
            },
            {
              path: "",
              component: GeneroPlano
            }
          ]
        }
      ]
    },
    {
      path: "/download",
      redirect: to => {
        // http://177.66.114.4/download/teste.zip
        window.open("http://177.66.114.4/download/", "_blank");
      }
    },
    { path: "*", name: "not_found", component: Start }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
